import { TranslateService } from '@ngx-translate/core';
import { ClinicalDocument, ClinicalDocumentData } from './clinical-document.model';
export class PatientNote extends ClinicalDocument {
  type = 'note';

  constructor(
    data: ClinicalDocumentData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
  }

  public get label() {
    return this.translateService.instant('note_title', { title: this.title });
  }
}
